import { useEffect } from "react";
export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = `Huming - ${title}`;
  }, [title]);

  return null;
};
